import paths from "@icarius-router/paths";
import { getLocalizedString } from "@icarius-localization/strings";
import {
    dateClassRule,
    dateFormatter,
    dateValueGetter,
    dateFilterParams,
    dateComparator,
} from "@icarius-table/date";
import { numberComparatorMax3, numberFilterParamsWithThreeDigits, createNumberFormatter } from "@icarius-table/number";

export default () => [
    {
        pages: [paths.positionEditor],
        config: {
            headerName: getLocalizedString("positionEditorId"),
            field: "ID",
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: [paths.positionEditor],
        config: {
            headerName: getLocalizedString("positionEditorPositionName"),
            field: "Nombre del cargo",
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: [paths.positionEditor],
        config: {
            headerName: getLocalizedString("positionEditorPositionQuantity"),
            field: "Cantidad de puestos",
            filter: "agTextColumnFilter",
            comparator: numberComparatorMax3,
            filterParams: numberFilterParamsWithThreeDigits(),
            chartDataType: "series",
            cellClass: "currencyValue",
            valueFormatter: createNumberFormatter(0, 3),
            enableValue: true,
            allowedAggFuncs: ["sum", "min", "max", "avg"],
        }
    },
    {
        pages: [paths.positionEditor],
        config: {
            headerName: getLocalizedString("positionEditorOccupiedPositions"),
            field: "Puestos ocupados",
            filter: "agTextColumnFilter",
            comparator: numberComparatorMax3,
            filterParams: numberFilterParamsWithThreeDigits(),
            chartDataType: "series",
            cellClass: "currencyValue",
            valueFormatter: createNumberFormatter(0, 3),
            enableValue: true,
            allowedAggFuncs: ["sum", "min", "max", "avg"],
        }
    },
    {
        pages: [paths.positionEditor],
        config: {
            headerName: getLocalizedString("positionEditorFreePositions"),
            field: "Puestos libres",
            filter: "agTextColumnFilter",
            comparator: numberComparatorMax3,
            filterParams: numberFilterParamsWithThreeDigits(),
            chartDataType: "series",
            cellClass: "currencyValue",
            valueFormatter: createNumberFormatter(0, 3),
            enableValue: true,
            allowedAggFuncs: ["sum", "min", "max", "avg"],
        }
    },
    {
        pages: [paths.positionEditor],
        config: {
            headerName: getLocalizedString("positionEditorResponsabilityDegree"),
            field: "Grado de responsabilidad",
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: [paths.positionEditor],
        config: {
            headerName: getLocalizedString("positionEditorSuperior"),
            field: "Cargo superior",
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: [paths.positionEditor],
        config: {
            headerName: getLocalizedString("positionEditorAssistant"),
            field: "Asistente",
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: [paths.positionEditor],
        config: {
            field: "Potencial motivador del cargo",
            headerName: getLocalizedString("motivatorPotential"),
            filter: "agTextColumnFilter",
            comparator: numberComparatorMax3,
            filterParams: numberFilterParamsWithThreeDigits(),
            chartDataType: "series",
            cellClass: "currencyValue",
            valueFormatter: createNumberFormatter(0, 3),
            enableValue: true,
            allowedAggFuncs: ["sum", "min", "max", "avg"],
        }
    },
    {
        pages: [paths.positionEditor],
        config: {
            field: "Fecha actualización del potencial",
            headerName: getLocalizedString("potentialUpdateDate"),
            filter: "agTextColumnFilter",
            comparator: dateComparator,
            filterParams: dateFilterParams(),
            cellClassRules: dateClassRule,
            valueFormatter: dateFormatter,
            valueGetter: dateValueGetter,
        }
    },
    {
        pages: [paths.positionEditor],
        config: {
            field: "Etiquetas",
            headerName: getLocalizedString("tagTitle"),
            filter: "agTextColumnFilter",
        }
    },
    {
        pages: [paths.positionEditor],
        config: {
            field: "Grupo de competencias específicas",
            headerName: getLocalizedString("specificCompetencyGroup"),
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: [paths.positionEditor],
        config: {
            field: "Grupo de evaluación",
            headerName: getLocalizedString("evaluationGroup"),
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: ["positionOccupation"],
        config: {
            headerName: getLocalizedString("employeeCode"),
            field: "Código de empleado",
            filter: "agTextColumnFilter",
            chartDataType: "series",
            checkboxSelection: function (params) {
                return params.columnApi.getRowGroupColumns().length === 0;
            },
            headerCheckboxSelection: function (params) {
                return params.columnApi.getRowGroupColumns().length === 0;
            },
            headerCheckboxSelectionFilteredOnly: true,
            enableRowGroup: true,
        }
    },
    {
        pages: ["positionOccupation"],
        config:
        {
            headerName: getLocalizedString("nameAndSurname"),
            field: "Apellido y nombres",
            filter: "agTextColumnFilter",
        }
    },
    {
        pages: ["positionOccupation"],
        config: {
            headerName: getLocalizedString("plantPersonnel"),
            field: "Personal de planta",
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: ["positionOccupation"],
        config: {
            headerName: getLocalizedString("positionEditorAssistant"),
            field: "Asistente",
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: ["positionOccupation"],
        config: {
            headerName: getLocalizedString("management"),
            field: "Gerencia",
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: ["positionOccupation"],
        config: {
            headerName: getLocalizedString("department"),
            field: "Departamento",
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: ["positionOccupation"],
        config: {
            headerName: getLocalizedString("section"),
            field: "Seccion",
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: ["positionOccupation"],
        config: {
            headerName: getLocalizedString("costCenter"),
            field: "Centro de costo de gestión",
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: ["positionOccupation"],
        config: {
            headerName: getLocalizedString("businessUnit"),
            field: "Unidad de negocio",
            filter: "agSetColumnFilter",
        }
    },
]